module.exports = __webpack_public_path__ + "img/image 34.c813e73c.svg";